export default __webpack_public_path__ + "static/media/Legend4.794a19a3.jpeg";